var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"classes":"my-notifi","width":"400","duration":2000,"position":"right top"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }